import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ProxyHistory } from 'src/app/model/proxyHistory';
import { AdminService } from 'src/app/service/admin.service';

@Component({
  selector: 'app-proxy-history',
  templateUrl: './proxy-history.component.html',
  styleUrls: ['./proxy-history.component.scss']
})
export class ProxyHistoryComponent implements OnInit {

  proxyHistoryData = new MatTableDataSource<ProxyHistory>();
  proxyHistoryColumns = ['id', 'action', 'datetime', 'admin', 'user', 'host'];

  /** True enquanto carrega — exibe os cards-placeholder. */
  loading = true;
  /** Texto do filtro (busca em chip no header). */
  search = '';

  @ViewChild(MatSort, { static: false }) set content(sort: MatSort) {
    if (sort) {
      this.proxyHistoryData.sort = sort;
      this.proxyHistoryData.sortingDataAccessor = (history: ProxyHistory, header: string) => {
        switch (header) {
          case 'id': return history.id;
          case 'action': return history.action;
          case 'datetime': return history.createdAt.valueOf();
          case 'admin': return history.admin.name;
          case 'user': return history.user.name;
          case 'host': return history.host;
          default: return history.id;
        }
      };
    }
  }

  constructor(
    private adminService: AdminService
  ) {
    // Filtro por admin / usuário / IP / id / ação (acento-insensível).
    this.proxyHistoryData.filterPredicate = (h: ProxyHistory, filter: string) => {
      const normalize = (v: any) =>
        (v || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
      return normalize(
        `${h.id} ${h.action || ''} ${h.admin?.name || ''} ${h.user?.name || ''} ${h.host || ''}`
      ).includes(filter);
    };
  }

  ngOnInit(): void {
    this.initData();
  }

  initData(): void {
    this.loading = true;
    this.adminService.getProxyHistory().subscribe(
      data => {
        this.proxyHistoryData.data = data;
        this.loading = false;
      },
      () => { this.loading = false; }
    );
  }

  applyFilter(): void {
    const normalize = (v: any) =>
      (v || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
    this.proxyHistoryData.filter = normalize(this.search);
  }
}
